/**
 * The available types of slides
 */
export enum SlideType {
  YACHT = 'yacht',
  ITINERARY = 'itinerary',
  VESSEL = 'vessel',
}
